export default __webpack_public_path__ + "static/media/size-max.dc46977f.svg";